import { Button, ButtonVariant } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { CARD_FIELD_TYPE, CardsContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import cardFieldsDefault from "src/modules/pe-landing-module/data/utils/cardFieldsDefault"

/* Protopia Ecosystem component */
export interface ICardFieldTypeFieldProps {
   onChoose: (key: CARD_FIELD_TYPE) => void
}
const CardFieldTypeField = (props: ICardFieldTypeFieldProps): JSX.Element => {
    const currentCardEdit: CardsContent	= useLandingStore( (state: ILandingStore) => state.currentCardEdit ) 
    const exclude: CARD_FIELD_TYPE[] = currentCardEdit.card_fields.map(cf => cf.type as CARD_FIELD_TYPE)

    return <div className='pe-card-field-type-field-container overflow-y-auto'>
        {
            Object.values(CARD_FIELD_TYPE)
            .filter( (key: CARD_FIELD_TYPE) => {
                if( exclude ) {
                    return !exclude.includes( key )
                }
                return true
            })
            .map(key => {
                return <Button variant={ ButtonVariant.MINIMAL } size="small" alignText="left" onClick={() => props.onChoose( key ) }>
                    <div className="small d-flex w-100">
                        <img src={ cardFieldsDefault()[key]?.icon } alt="" height={ 14 } className="invert-image mr-1" />
                        <div className="small text-light">
                            <div>{ __( key ) }</div>
                        </div> 
                    </div> 
                </Button>
            })
        }
    </div>
}
export default CardFieldTypeField